(function($){


$('.header__nav-button').click(function(){

  $('body').toggleClass('open-menu');
  $('.mobile-menu').addClass('open_menu')


})

$('.page-overlay').click(function(){

  $('body').removeClass('open-menu');
  $('.mobile-menu').removeClass('open_menu')

})

$('.close_cart').click(function(){
  $('body').removeClass('no-scroll cart-open');
  $('.page-overlay').removeClass('active');
   $('.g_side_cart').removeClass('active')
})


// window.addEventListener('scroll', () => {
//   const bar = document.querySelector('.sticky-bar');
//   bar.style.transform = `translateY(${window.scrollY}px)`;
// });





// Close menu
document.querySelectorAll('.close-menu').forEach(function(btn) {
  btn.addEventListener('click', function() {
    // Close the main mobile menu
    document.querySelectorAll('.mobile-menu').forEach(function(menu) {
      menu.classList.remove('open_menu');
    });

    // Close all open sub-panels
    document.querySelectorAll('.menu_sidebar_sub-panel.open').forEach(function(panel) {
      panel.classList.remove('open');
    });
  });
});

// Open submenu
document.querySelectorAll('.submenu_click').forEach(function(item) {
  item.addEventListener('click', function() {
    const nextPanel = item.nextElementSibling;
    if (nextPanel && nextPanel.classList.contains('menu_sidebar_sub-panel')) {
      nextPanel.classList.add('open');
    }
  });
});

// Back button inside submenu
document.querySelectorAll('.menu_back-button').forEach(function(button) {
  button.addEventListener('click', function() {
    const parentPanel = button.closest('.menu_sidebar_sub-panel');
    if (parentPanel) {
      parentPanel.classList.remove('open');
    }
  });
});

  

$(document).on('click', '.page-overlay', function(){
 $('body').removeClass('no-scroll cart-open');
  $(this).removeClass('active');
  $('.g_side_cart').removeClass('active')
})


 if (window.innerWidth <= 992) {
  $('.nav_element .plus').click(function(){
    $(this).toggleClass('active');
    $(this).next('.megamenu_wrap').toggle(500)
  });
//  $('.nav_element').attr('href', 'javascript:;');
 }
$('.close-menu').click(function(){
 $('body').toggleClass('open-menu')
})



function col_banners(){

$('.col_banner_img>a').each(function(){

  $(this).find('img').hide();

  var _Bg = 'url('+ $(this).find('img').attr('src') + ')';

  $(this).css("background-image", _Bg);

  $(this).find('img').hide();

});
} 
col_banners();
document.addEventListener('facets:applied', (e) => {
  const { sectionId, urlParameters, url } = e.detail;
  console.log('Filters applied (post-render):', sectionId, url);

});

  $('.h-collection-list li a').on('click', function(){
		   	var target = $(this).attr('data-rel');
			$('.h-collection-list li a').removeClass('active');
		   	$(this).addClass('active');
		   	$("#"+target).fadeIn('slow').siblings(".tab-box").hide();
		   	return false;
  });


  $('.announcement-bar-slides').slick({
  slidesToShow: 1,
  autoplay: true,
  slidesToScroll: 1,
  arrows: false,
  dots: false,
    prevArrow:"<button type='button' class='slick-prev small-icon'><svg width='10' height='15' viewBox='0 0 10 15' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M3.84087 7.50004L9.60226 2.15191C10.1326 1.65963 10.1326 0.861486 9.60226 0.369206C9.07194 -0.12307 8.21212 -0.123069 7.68181 0.369211L0 7.50004L7.68182 14.6308C8.21213 15.1231 9.07193 15.1231 9.60225 14.6308C10.1326 14.1385 10.1326 13.3404 9.60225 12.8481L3.84087 7.50004Z' fill='Currentcolor'/></svg></button>",
  nextArrow:"<button type='button' class='slick-next small-icon'><svg width='10' height='15' viewBox='0 0 10 15' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M6.15913 7.50005L0.397739 2.15191C-0.132581 1.65963 -0.132579 0.861486 0.397742 0.369207C0.928061 -0.12307 1.78787 -0.123069 2.31819 0.369211L10 7.50005L2.31818 14.6308C1.78787 15.1231 0.928067 15.1231 0.397752 14.6308C-0.132573 14.1385 -0.132573 13.3404 0.397753 12.8481L6.15913 7.50005Z' fill='currentcolor'/></svg></button>",
  centerMode: false
  });


if (window.matchMedia("(max-width: 767px)").matches) {

 $('.product_for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
    dots: false,
  fade: true,
  asNavFor: '.product_thumb'
});



  $('.product_thumb').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  asNavFor: '.product_for',
  arrows: false,
  dots: false,
    prevArrow:"<button type='button' class='slick-prev small-icon'><svg width='10' height='15' viewBox='0 0 10 15' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M3.84087 7.50004L9.60226 2.15191C10.1326 1.65963 10.1326 0.861486 9.60226 0.369206C9.07194 -0.12307 8.21212 -0.123069 7.68181 0.369211L0 7.50004L7.68182 14.6308C8.21213 15.1231 9.07193 15.1231 9.60225 14.6308C10.1326 14.1385 10.1326 13.3404 9.60225 12.8481L3.84087 7.50004Z' fill='Currentcolor'/></svg></button>",
  nextArrow:"<button type='button' class='slick-next small-icon'><svg width='10' height='15' viewBox='0 0 10 15' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M6.15913 7.50005L0.397739 2.15191C-0.132581 1.65963 -0.132579 0.861486 0.397742 0.369207C0.928061 -0.12307 1.78787 -0.123069 2.31819 0.369211L10 7.50005L2.31818 14.6308C1.78787 15.1231 0.928067 15.1231 0.397752 14.6308C-0.132573 14.1385 -0.132573 13.3404 0.397753 12.8481L6.15913 7.50005Z' fill='currentcolor'/></svg></button>",
  centerMode: false,
  focusOnSelect: true,
  responsive: [
     {
      breakpoint: 767,
      settings: {
       arrows: false

      }
    },

  ]
});
	
}


$('.insta_slide').slick({
  dots: false,
   arrows: false,
  infinite: true,
  prevArrow:"<button type='button' class='slick-prev small-icon'><svg width='10' height='15' viewBox='0 0 10 15' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M3.84087 7.50004L9.60226 2.15191C10.1326 1.65963 10.1326 0.861486 9.60226 0.369206C9.07194 -0.12307 8.21212 -0.123069 7.68181 0.369211L0 7.50004L7.68182 14.6308C8.21213 15.1231 9.07193 15.1231 9.60225 14.6308C10.1326 14.1385 10.1326 13.3404 9.60225 12.8481L3.84087 7.50004Z' fill='Currentcolor'/></svg></button>",
  nextArrow:"<button type='button' class='slick-next small-icon'><svg width='10' height='15' viewBox='0 0 10 15' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M6.15913 7.50005L0.397739 2.15191C-0.132581 1.65963 -0.132579 0.861486 0.397742 0.369207C0.928061 -0.12307 1.78787 -0.123069 2.31819 0.369211L10 7.50005L2.31818 14.6308C1.78787 15.1231 0.928067 15.1231 0.397752 14.6308C-0.132573 14.1385 -0.132573 13.3404 0.397753 12.8481L6.15913 7.50005Z' fill='currentcolor'/></svg></button>",
  slidesToShow:5,
   autoplay: true,
  autoplaySpeed: 1000,
  responsive: [
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 4.5

      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow:3,

      }
    },
    {

      breakpoint: 640,
      settings: {
        slidesToShow: 1.5,

      }

    }

  ]

});


if (window.matchMedia("(min-width: 767px)").matches) {
document.addEventListener("DOMContentLoaded", function () {
  const mainItems = document.querySelectorAll(".product_for .item");
  const thumbs = document.querySelectorAll(".product_thumb .item");

  // Function to update active thumbnail
  function setActiveThumb(index) {
    thumbs.forEach((thumb, i) => {
      thumb.classList.toggle("active", i === index);
    });
  }

  // Observe each main image with IntersectionObserver
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const index = Array.from(mainItems).indexOf(entry.target);
          setActiveThumb(index);
        }
      });
    },
    {
      root: null, // viewport
      threshold: 0.5 // at least 50% visible
    }
  );

  mainItems.forEach((item) => observer.observe(item));

  // Add click event to thumbnails
  thumbs.forEach((thumb, index) => {
    thumb.addEventListener("click", () => {
      mainItems[index].scrollIntoView({ behavior: "smooth", block: "center" });
      setActiveThumb(index);
    });
  });
});
}


 jQuery('.video-background').parent().click(function () {
	if ($(this).children(".video-background").get(0).paused) {
		$(this).children(".video-background").get(0).play(); $(this).children(".playpause").fadeOut();
	} else {
		$(this).children(".video-background").get(0).pause();
		$(this).children(".playpause").fadeIn();
	}
});

$(document).on("click", ".group-flex .qty-box .qty__adjust", function (e) {
  e.preventDefault(); // ✅ stop form submission / unwanted behavior

  var $btn = $(this);
  var $input = $btn.closest(".qty-box").find("input");
  var currentVal = parseFloat($input.val()) || 0;

  var newVal = $btn.hasClass("qty__adjust--plus")
    ? currentVal + 1
    : currentVal > 0
      ? currentVal - 1
      : 1;

  $input.val(newVal);
});

$(document).on("click", ".sticky-right .qty-box .qty__adjust", function (e) {
  e.preventDefault(); // ✅ stop form submission / unwanted behavior

  var $btn = $(this);
  var $input = $btn.closest(".qty-box").find("input");
  var currentVal = parseFloat($input.val()) || 0;

  var newVal = $btn.hasClass("qty__adjust--plus")
    ? currentVal + 1
    : currentVal > 0
      ? currentVal - 1
      : 1;

  $input.val(newVal);
});

// $('.open-inc').click(function(){
//   $('.ingredients_sidebar').addClass('active');
//   $('.product_detail').css('z-index', '51');
//   $('body').addClass('no-scroll');
// });

// $('.close_in').click(function(){
//   $('.ingredients_sidebar').removeClass('active');
//   $('.product_detail').css('z-index', '11');
//   $('body').removeClass('no-scroll');
// });
window.addEventListener('scroll', function () {
  const sticky = document.querySelector('.product_thumb');
  const container = document.querySelector('.product_wrap '); // Adjust selector to your actual container

  if (!sticky || !container) return;

  const scrollTop = window.scrollY;
  const containerRect = container.getBoundingClientRect();
  const stickyHeight = sticky.offsetHeight;
  const containerTop = container.offsetTop;
  const containerHeight = container.offsetHeight;

  // Bottom boundary of the sticky container
  const containerBottom = containerTop + containerHeight;

  // If scrollTop is within container range
  if (scrollTop >= containerTop && scrollTop + stickyHeight < containerBottom) {
    sticky.classList.add('fixed');
    sticky.classList.remove('bottom');
  }
  // If sticky would go below container
  else if (scrollTop + stickyHeight >= containerBottom) {
    sticky.classList.remove('fixed');
    sticky.classList.add('bottom');
  }
  // If above container
  else {
    sticky.classList.remove('fixed');
    sticky.classList.remove('bottom');
  }
});

if (window.matchMedia("(min-width: 767px)").matches) {
  document.addEventListener('DOMContentLoaded', function () {
    const thumbs = document.querySelectorAll('.product_thumb .item');
    const images = document.querySelectorAll('.product_for .item');

    // ----- Click event for thumbs -----
    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', function () {
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');

        const image = images[index];
        if (image) {
          image.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      });
    });

    // ----- Scroll event: sync thumbs with visible image -----
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
        console.log(entry.target);
          const index = Array.from(images).indexOf(entry.target);

          // Remove active from all thumbs
          thumbs.forEach(t => t.classList.remove('active'));
          // Add active to the matched thumb
          if (thumbs[index]) {
            console.log(thumbs[index]);
            thumbs[index].classList.add('active');
          }
        }
      });
    }, {
      root: document.querySelector('.product_for'), // container that scrolls
      threshold: 0.6 // % of image in view before it becomes active
    });

    images.forEach(image => observer.observe(image));
  });
}



   $(document).on('click', '.filter-title', function(){
$(this).toggleClass('active');
    $(this).next('.filter_toggle').toggle(500);
});

$(document).on('click', '.filter_link', function(){
  $('body').addClass('filter-open ')
})

$('.close_fliter, .page-overlay').click(function(){
  $('body').removeClass('filter-open ')
})




$('.seach_icon').click(function() {
  $('body').addClass('search-open');
  $('#goal').focus(); 
});

$(document).on('click', '.search_close', function(){
 $('body').removeClass('search-open');
})

setTimeout(function() {
    var loader = document.getElementById('page-loader');
    if (loader) {
      loader.style.display = 'none';
    }
  }, 3000);



 document.querySelectorAll('.price-range input[type="radio"]').forEach(radio => {
  radio.addEventListener('change', function() {
    let minInput = document.querySelector('.custom-price input[name*="min"]');
    let maxInput = document.querySelector('.custom-price input[name*="max"]');
    let [min, max] = this.value.split('-');
    minInput.value = min;
    maxInput.value = max;
    // Auto-submit filter form
    document.getElementById('CollectionFiltersForm').submit();
  });
});

// if (window.matchMedia("(min-width: 767px)").matches) {
// gsap.registerPlugin(ScrollTrigger);

// gsap.utils.toArray(".intro").forEach((img) => {
//   gsap.fromTo(img, 
//     { xPercent: -5 }, // start offset (left side)
//     { 
//       xPercent: 0,    // move to right side
//       ease: "none",
//       scrollTrigger: {
//         trigger: img,
//         scrub: true,   // smooth scroll-based animation
//         start: "top bottom", 
//         end: "bottom top"
//       }
//     }
//   );
// });
// }
// gsap.utils.toArray(".Scent_img img").forEach((img) => {
//   gsap.fromTo(img, 
//     { xPercent: -8 }, // start offset (left side)
//     { 
//       xPercent: 0,    // move to right side
//       ease: "none",
//       scrollTrigger: {
//         trigger: img,
//         scrub: true,   // smooth scroll-based animation
//         start: "top bottom", 
//         end: "bottom top"
//       }
//     }
//   );
// });



// document.addEventListener("DOMContentLoaded", () => {
//  setTimeout(function(){
//    const paths = document.querySelectorAll("#oke-star-symbols path");

//   paths.forEach(path => {
//     path.removeAttribute("fill");
//     path.removeAttribute("stroke");
//   });
//  },1000);
// });


  AOS.init();

})(jQuery);










